import { adminApi } from '../../../../store/generated/admin/organization-record-values';
import { UserContextApiTags } from '../../../../common/api/userContextApi';

export const OrganizationRecordValueApiTags = {
  OrganizationRecordValue: 'OrganizationRecordValue',
} as const;

const taggedApi = adminApi.enhanceEndpoints({addTagTypes: Object.values(OrganizationRecordValueApiTags),});

export const organizationRecordValueApi = taggedApi.enhanceEndpoints({
  addTagTypes: [
    OrganizationRecordValueApiTags.OrganizationRecordValue,
    UserContextApiTags.OrganizationContext,
  ],
  endpoints: {
    apiAdminV1OrganizationRecordValuesList: {
      providesTags: [OrganizationRecordValueApiTags.OrganizationRecordValue],
    },
    apiAdminV1OrganizationRecordValuesCreate: {
      invalidatesTags: [
        OrganizationRecordValueApiTags.OrganizationRecordValue,
        UserContextApiTags.OrganizationContext,
      ],
    },
    apiAdminV1OrganizationRecordValuesRetrieve: {
      providesTags: [OrganizationRecordValueApiTags.OrganizationRecordValue],
    },
    apiAdminV1OrganizationRecordValuesUpdate: {
      invalidatesTags: [
        OrganizationRecordValueApiTags.OrganizationRecordValue,
        UserContextApiTags.OrganizationContext,
      ],
    },
    apiAdminV1OrganizationRecordValuesDestroy: {
      invalidatesTags: [
        OrganizationRecordValueApiTags.OrganizationRecordValue,
        UserContextApiTags.OrganizationContext,
      ],
    },
  },
});
